import newTranslog from '@/components/NewTrans/index.js'


export default{
    components:{
        newTranslog
    },
    data() {
        return{
            TransLogs:[],
            recordtotal:0,
            pageSize:20,
            pageIndex:1,
            sBillNo:'',
            sDeveliverDtFrom:'',
            sDeveliverDtTo:'',
            sStoreDtFrom:'',
            sStoreDtTo:'',
            sDestination:'',
            sReceiptStatus:'',
            sGoodsStatus:'',
            collapsed:false,

            searchview:[],
            rstatusitems:[
                {Id:'Y',Text:'已回'},
                {Id:'N',Text:'未回'}
            ],
            customers:[],
            carriers:[],
            statusItems:[
                {Id:'C',Text:'无异常'},
                {Id:'L',Text:'多货'},
                {Id:'M',Text:'少货'},
                {Id:'N',Text:'未签收'}
            ],
            reasons:[
                {value:'R0001',text:'未出货'},
                {value:'R0002',text:'保质期'},
                {value:'R0003',text:'破损'},
                {value:'R0004',text:'多货'},
                {value:'R0005',text:'条码异常'},
                {value:'R0006',text:'内包装缺少'},
                {value:'Other',text:'其他'},
            ],
            BackRemarkItems:[
                {value:'Y',text:'已结束'},
                {value:'N',text:'未结束'},
            ],
            CurrentTransLog:[],
            editFormVisible:false,
            CurrentTransLogImages:[],

            searching:false,
            SortDtOder:'',
            DeveliverDtOrder:'',
            fullscreen: false,
            tableHeight:'', 
            headerStyle :'tableheaderStyle',        

            dialogImportVisible:false,
            isAlreadyImported:false,
            importname:'',
            viewTheHints:'',
            uploading:false,
            fileaction:'',
            fileList:[],
            
            selectedCustomer:'',
            timer : null
        }
    },
    watch: {
        editFormVisible: {
            handler(newName, oldName) 
            {
                if(newName!=oldName && newName == false)
                {
                    this.refresheditlog(); // 更新当前编辑的对象
                    
                }
            },
        deep: false,
        immediate: false
        },
    },
    
    mounted () {
        var me = this;
        this.LoadData();
        
        var hostURL = this.$axios.defaults.baseURL;
        this.fileaction = hostURL+ "upload/postfile";

        var element = document.getElementById('content');
        this.tableHeight = window.innerHeight - element.offsetTop - 65;

        this.start();
    },
    
    methods: {
        LoadData(){
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            
            this.getcustomers(user);
            this.getcarriers(user);
            this.gettranslogs(user);
        },
        handlesearch(){
            this.searching = true;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            this.pageIndex = 1;
            this.gettranslogs(user);
        },
        tableRowClassName({row, rowIndex}) {
            console.log(row.GoodsStatus);
            if(row.GoodsStatus == '未签收') {
                 return 'warning-row'
            } 
            else{
                return 'success-row'
            }
        },
        gettranslogs(user){
            var me = this;
            var getLogsMethod = 'BusinessTrans/getlist';

            var customerids = '';
            me.searchview.CustomerId.forEach(element=>{
                customerids  = customerids + element +',';
            });
            console.log(me.searchview.Reason);
            var reason = '';
            if(me.searchview.Reason!='undefined' && me.searchview.Reason!=null){
                me.searchview.Reason.forEach(element=>{
                    reason += element+",";
                });
            }

            var backremark = '';
            if(me.searchview.BackRemark!='undefined' && me.searchview.BackRemark!=null){
                me.searchview.BackRemark.forEach(element=>{
                    backremark += element+",";
                });
            }

            this.$axios.get(getLogsMethod,
                {
                    params: {
                        'CurrentTokenId': user.TokenId,
                        'CurrentUser': user.LoginName,  
                        'CustomerId': customerids,//me.searchview.CustomerId,
                        'DeveliverDtFrom':me.searchview.DeveliverDtFrom,
                        'DeveliverDtTo':me.searchview.DeveliverDtTo,
                        'BillNo':me.searchview.BillNo,
                        'Destination':me.searchview.Destination,
                        'ReceiptStatus':me.searchview.ReceiptStatus,
                        'Carrier': me.searchview.Carrier,
                        'GoodsStatus':me.searchview.GoodsStatus,
                        'BillNo3':me.searchview.BillNo3,
                        'ProCode':me.searchview.ProCode,
                        'ProName':me.searchview.ProName,
                        'Reason': reason,//me.searchview.Reason,
                        'BackRemark': backremark,//me.searchview.BackRemark,
                        'BillNo2':me.searchview.BillNo2,
                        'StoreDtFrom':me.searchview.StoreDtFrom,
                        'StoreDtTo':me.searchview.StoreDtTo,
                        'PO':me.searchview.PO,
                        'Receiver':me.searchview.Receiver,
                        'PageSize':me.pageSize,
                        'CurrentIndex':me.pageIndex -1,
                        'SortDtOder':me.SortDtOder,
                        'DeveliverDtOrder':me.DeveliverDtOrder,
                    }
                })
            .then((response) => {
                if (response.status === 200) {
                    if(response.data.IsSuccess)
                    {
                        console.log(response.data.Data.DataSource);
                        me.TransLogs = response.data.Data.DataSource;
                        me.recordtotal = response.data.Data.TotalRecords;
                        //me.pageIndex = 1;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
                this.searching = false;
            })
            .catch(function (error) {
                this.alert(error);
                this.searching = false;
            });
        },
        getcustomers(user){
            var me = this;
            var getMethod = "common/getcustomerlist/"+ user.TokenId;

            this.$axios.get(getMethod)
            .then((response) => {
                if (response.status === 200) {
                    if(response.data.IsSuccess)
                    {
                        me.customers = response.data.Data;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
            });
        },
        getcarriers(user){
            var me = this;
            
            var getMethod = "common/getcarrierlist/"+ user.TokenId;

            this.$axios.get(getMethod)
            .then((response) => {
                if (response.status === 200) {
                    if(response.data.IsSuccess)
                    {
                        me.carriers = response.data.Data;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
            });
        },
        refresheditlog(){
            var isSave = sessionStorage.getItem('saveornot');

            if(isSave == 'Y' && this.CurrentTransLog!=null && this.CurrentTransLog!=undefined)
            {
                var me = this;
                var user = sessionStorage.getItem('user');
                if (user) {
                    user = JSON.parse(user);
                }
                var getMethod = "BusinessTrans/get/"+user.TokenId+"/"+user.LoginName+"/"+ this.CurrentTransLog.Id;
                this.$axios.get(getMethod)
                .then((response) => {
                        if(response.data.IsSuccess)
                        {
                            var newLog = response.data.Data;

                            //刷新列表
                            var logs = [];
                            this.TransLogs.forEach(element=>{
                                if(element.Id == this.CurrentTransLog.Id)
                                {
                                    logs.push(newLog);
                                }
                                else
                                {
                                    logs.push(element);
                                }
                            });
                            this.TransLogs = logs;
                    }
                })
                .catch(function (error) {
                    console.log(error)
                });
            }
        },
        handleCurrentChange(val)
        {
            this.pageIndex = val;
            this.LoadData()
        },
        collapse: function() {
            this.collapsed = !this.collapsed;
        },
        formatterController:function(row, column) { 
            var date_str = row[column.property];
            if (date_str === undefined) {
              return "";
            }
            var date = new Date(date_str);
            return date.Format("yyyy-MM-dd");
        },
        formatterDecimal:function(row,column){
            var dig_str = row[column.property];
            if (dig_str === undefined || dig_str == null ) {
              return "";
            }
            var dig = parseFloat(dig_str);
            return dig.toFixed(2);
        },
        handleEdit(row, event){
            this.editFormVisible = true;
            this.CurrentTransLog = Object.assign({}, row);

            sessionStorage.setItem('saveornot', 'N');
            var count = this.CurrentTransLog.TransLogImages.length;

            if(count>0)
            {
                var timages = [];

                this.CurrentTransLog.TransLogImages.forEach(element=>{
                    timages.push({
                        'name':element.FileName,
                        'url': element.FileGuid,
                        'Id' : element.Id,
                        'BusinessTransId' : element.BusinessTransId
                    });
                });

                this.CurrentTransLogImages = timages;
            }
            else
            {
                this.CurrentTransLogImages = [];
            }
        },
        handleDelete(index, row) {
            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
              }).then(() => {
                var me = this;
                var user = sessionStorage.getItem('user');
                if (user) {
                    user = JSON.parse(user);
                }
                    var Method = 'BusinessTrans/delete/'+user.TokenId+"/"+user.LoginName+"/"+ row.Id;
                    this.$axios.post(Method)
                    .then((response) => {
                            if(response.data.IsSuccess)
                            {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            
                                var newTrans = [];
                                    
                                me.TransLogs.forEach(element => {
                                    if(element.Id!=row.Id)
                                    newTrans.push(element);
                                    });

                                me.TransLogs = newTrans;
                                me.recordtotal -= 1;
                            }
                            else
                            {
                                var strMsg = '';
                                response.data.Messages.forEach(element => {
                                    strMsg += element.Message +'\r\n';
                                });
                                
                                this.$alert(strMsg);
                            }
                    })
                    .catch(function (error) {
                        this.$alert(error);
                    }); 
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
        },
        handleExport(){
            this.searching = true;
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var reason = '';
            if(me.searchview.Reason!='undefined' && me.searchview.Reason!=null){
                me.searchview.Reason.forEach(element=>{
                    reason += element+",";
                });
            }

            var backremark = '';
            if(me.searchview.BackRemark!='undefined' && me.searchview.BackRemark!=null){
                me.searchview.BackRemark.forEach(element=>{
                    backremark += element+",";
                });
            }

            var customerids = '';
            me.searchview.CustomerId.forEach(element=>{
                customerids  = customerids + element +',';
            });

            var getLogsMethod = 'BusinessTrans/export2';
            this.$axios.get(getLogsMethod,
                {
                    params: {
                        'CurrentTokenId': user.TokenId,
                        'CurrentUser': user.LoginName,
                        'CustomerId': customerids,//me.searchview.CustomerId,
                        'DeveliverDtFrom':me.searchview.DeveliverDtFrom,
                        'DeveliverDtTo':me.searchview.DeveliverDtTo,
                        'BillNo':me.searchview.BillNo,
                        'Destination':me.searchview.Destination,
                        'ReceiptStatus':me.searchview.ReceiptStatus,
                        'Carrier': me.searchview.Carrier,
                        'GoodsStatus':me.searchview.GoodsStatus,
                        'BillNo3':me.searchview.BillNo3,
                        'ProCode':me.searchview.ProCode,
                        'ProName':me.searchview.ProName,
                        'Reason': reason,//me.searchview.Reason,
                        'BackRemark':backremark,//me.searchview.BackRemark,
                        'BillNo2':me.searchview.BillNo2,
                        'StoreDtFrom':me.searchview.StoreDtFrom,
                        'StoreDtTo':me.searchview.StoreDtTo,
                        'PO':me.searchview.PO,
                        'Receiver':me.searchview.Receiver,
                        'PageSize':me.pageSize,
                        'CurrentIndex':me.pageIndex -1,
                    }
                })
            .then((response) => {

               // this.searching = false;

                if(true) {
                    if(response.data.IsSuccess)
                    {
                        //TODO: Download the file
                        //var attachmentURL = "http://bxw2341450056.my3w.com/api/tempexportfile/" + response.data.Data;
                       // window.location = attachmentURL;
                       me.downloadFile('export.xlsx',response.data.Data);
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
               // this.searching = false;
                console.log(error);
            });
        },
        downloadFile(fileName, content) {
            const blob = this.base64ToBlob(content); // new Blob([content]);
      
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
       
              //此写法兼容可火狐浏览器
              document.body.appendChild(link);
              const evt = document.createEvent("MouseEvents");
              evt.initEvent("click", false, false);
              link.dispatchEvent(evt);
              document.body.removeChild(link);
            }
        },
        base64ToBlob(code) {
        const raw = window.atob(code);
        const rawLength = raw.length;
        const uInt8Array = new Uint8Array(rawLength);
        for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
        }
        return new Blob([uInt8Array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        },

        querySearch(queryString, cb) {
            var me = this;
            var custs = [];
            if(queryString!='' && queryString!=undefined)
            {
                this.customers.forEach(element=>{
                    if(element.Desc.indexOf(queryString)>-1)
                    custs.push(element);
                });
            }
            // 调用 callback 返回建议列表的数据
            cb(custs);
        }, 
        handleSelect(item) {
        this.searchview.Customer = item.Desc;
        } ,
        querySearchC(queryString, cb) {
        var me = this;
        var custs = [];
        if(queryString!='' && queryString!=undefined)
        {
            this.carriers.forEach(element=>{
                if(element.Desc.indexOf(queryString)>-1)
                custs.push(element);
            });
        }
        // 调用 callback 返回建议列表的数据
        cb(custs);
        }, 
        handleSelectC(item) {
            this.searchview.Carrier = item.Desc;
        },
        changeTableSort(column) {
            if (column.prop === 'DeveliverDt') {
               if (column.order === 'descending') {
                   this.DeveliverDtOrder = "Desc";
               } else if (column.order === 'ascending') {
                  this.DeveliverDtOrder = "Asc";
               }
               this.SortDtOder = "";
             } 
             else if (column.prop === 'StoreDt') {
               if (column.order === 'descending') {
                   this.SortDtOder = "Desc";
               } else if (column.order === 'ascending') {
                   this.SortDtOder = "Asc";
               }
               this.DeveliverDtOrder = "";
             } 
             

             this.LoadData();
        },
        fullScreen () {
            var element = document.getElementById('content');
            var requestMethod = element.requestFullScreen 
                ||element.webkitRequestFullScreen 
                ||element.mozRequestFullScreen 
                ||element.msRequestFullScreen;
          if (requestMethod) {
            requestMethod.call(element);
          } 
          else if (typeof window.ActiveXObject !== 'undefined') {
            var wscript = new ActiveXObject('WScript.Shell');
            if (wscript !== null) {
              wscript.SendKeys('{F11}');
            }
        }
        },
        handleFullScreen(){
            var element = document.getElementById('content');
            var totalHeight = document.body.clientHeight; //分辨率宽度
            var tableHeight = (totalHeight - 250);

        // var table = document.getElementById("content");
        //   if (table= undefined && table != null) {
        //     table.style.height = inputWidth + "px";
        //   }
        if(element!='undefined'){
            element.style.height = tableHeight + "px"; 
            element.style.overflow = "auto"; 
        }
            
            if (this.fullscreen) {
              if (document.exitFullscreen) {
                document.exitFullscreen();
              } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
              } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
              } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
              }
            } else {
              if (element.requestFullscreen) {
                element.requestFullscreen();
              } else if (element.webkitRequestFullScreen) {
                element.webkitRequestFullScreen();
              } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
              } else if (element.msRequestFullscreen) {
                // IE11
                element.msRequestFullscreen();
              }
            }
            this.fullscreen = !this.fullscreen;
        },

        handleImport(){
            this.dialogImportVisible = true;
            this.isAlreadyImported = false;
            this.importname = '';
        },
        handleClose(){
            this.dialogImportVisible = false;
        },

        //上传之前验证文件格式是否正确
        beforeUpload(file){
            var me = this;
            me.isAlreadyImported = false;
            me.importname = '';
            me.viewTheHints = '';

            var ss = file.name.substr(file.name.lastIndexOf(".")).toUpperCase();//得到的是后缀名,且转换为大写
            var isValid = true;
            if(ss == ".XLS" || ss ==".XLSX"){
                isValid = true;
            }else{
                isValid = false;
            }

            //var isValid= file.type === 'application/vnd.msbef-excel' || file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            if (!isValid) {
                this.$alert('错误的文件格式，仅接受后缀名为.xls,.xlsx的文件。');
            }
            else
            {
                this.importname = file.name;
                this.uploading = true;
            }
            return isValid;
        },
        uploadSuccess(file,res){
            var me = this;

            console.log(file);
            var fileName= file[0];
            
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            
            this.invokePostService("BusinessTrans/ImportData",
                {
                    'LoginName': user.LoginName,
                    'FileName': fileName
                },
                (response)=>{
                    console.log(response);
                    this.isAlreadyImported = true;

                    var hostURL = this.$axios.defaults.baseURL;
                    this.excelHref= fileName;
                    debugger;
                    this.viewTheHints= '总计上传记录：'+response.data.Data.TotalCount+'条，成功：'+response.data.Data.SucessCount+'条';
                    this.$alert("上传成功！");
                });

            this.uploading = false;
        },
        openExcel(){
            console.log(this.excelHref);
            debugger;
            this.invokeGetService("/BusinessTrans/DownloadImport_Result",
                {params:{
                    'fileName': this.excelHref,
                }
                },
                (response)=>{
                    console.log(response);
                    this.downloadFile(this.excelHref,response.data.Data);
                });
        },
        downloadFile(fileName, content) {
            const blob = this.base64ToBlob(content); // new Blob([content]);
      
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
       
              //此写法兼容可火狐浏览器
              document.body.appendChild(link);
              const evt = document.createEvent("MouseEvents");
              evt.initEvent("click", false, false);
              link.dispatchEvent(evt);
              document.body.removeChild(link);
            }
        },
        base64ToBlob(code) {
        const raw = window.atob(code);
        const rawLength = raw.length;
        const uInt8Array = new Uint8Array(rawLength);
        for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
        }
        return new Blob([uInt8Array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        },
        selectChanged(value) {
            this.selectedCustomer = '选择的客户：';
            this.customers.forEach(element=>{
                if(value.indexOf(element.Id)>=0)
                {
                    this.selectedCustomer += element.Desc+"；";
                }
            });
        },
        

        // 计算距离下一个下午5点的毫秒数
        getNextFivePM () {
            const now = new Date();
            let target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 17, 0, 0); // 17:00:00

            // 如果今天下午5点已过，则设为明天下午5点
            if (now.getHours() >= 17) {
                target.setDate(target.getDate() + 1);
            }
            return target.getTime() - now.getTime();
        },
 
        // 弹窗配置
        showReminder(strPO)  {
            
            this.$confirm(strPO, '提示', {
                confirmButtonText: '确定',
                dangerouslyUseHTMLString: true, // ⚠️ 必须设置为 true 才能解析 HTML
                type: 'warning',
                center: true,
                outerWidth:800,
                closeOnClickModal:false
            
              }).then(() => {
                console.log('eee');
              }).catch(() => {
              });
        },

        setNextReminder  ()  {
            if (this.timer) clearTimeout(this.timer);
            const delay = this.getNextFivePM();
            console.log('delay: '+delay);
            this.timer = setTimeout(() => {
                var user = sessionStorage.getItem('user');
                if (user) {
                    user = JSON.parse(user);
                }

                this.invokeGetService("/BusinessTrans/GetReminderPOMessage",
                {
                    params:{
                    'tokenid': user.TokenId,
                    'account': user.LoginName
                }
                },
                (response)=>{
                    if(response.status == '200'){
                        console.log(response);
                        var strPo= response.data.Messages[0].Message;
                        this.showReminder(strPo);
                    }
                });
            }, delay);
        },

        start() {
            this.setNextReminder(); 
            console.log('每日提醒服务已启动,,');
        },
        stop() {
            if (this.timer) {
            clearTimeout(timer);
            this.timer = null;
            }
            console.log('每日提醒服务已停止');
        }
    },
    
}




// WEBPACK FOOTER //
// ./src/components/MaintainTransLog/MaintainTransLog.js